import { React, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card, Stack, Spinner } from 'react-bootstrap';
import { useUserContext } from 'contexts/UserContext';
import * as api from 'services/api';
import './ControlCentresPanel.css';
import { useControlCentreContext } from 'contexts/ControlCentreContext';
import { useTranslation } from 'react-i18next';
export function ControlCentresPanel() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { userData } = useUserContext();
    const { controlCentre, updateControlCentre } = useControlCentreContext();
    //#region ---------------------------- STATES ----------------
    const [controlCentres, setControlCentres] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    //#endregion

    //#region ---------------------------- EFFECTS ---------------
    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await api.getControlCentres();
                if (response.status === 200) {
                    setControlCentres(response.data);
                } else {
                    setError(t('ccErrorRetrieving'));
                }
            } catch (error) {
                console.error(t('ccErrorRetrieving'), error);
                setError(t('ccErrorRetrieving'));
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);
    //#endregion

    //#region ---------------------------- HANDLERS --------------

    function handleControlCentreConfig(centreid, centretext) {
        if (userData && userData.role === 'Admin') {
            updateControlCentre({ ...controlCentre, centreid: centreid, centrename: centretext });
            navigate(`/controlCentreConfig/${centreid}`);
        }
    }
    //#endregion

    return (
        <Container fluid className="px-5 mt-5" style={{ maxWidth: '1280px' }}>
            <h2>{t('controlCentreList')}</h2>
            <Stack direction="horizontal" className="justify-content-start">
                {error && <p className="text-danger fw-semibold">{error}</p>}
            </Stack>
            {controlCentres.length > 0 && (
                <Stack direction="vertical" gap={3} className="mt-4 justify-content-between">

                    {controlCentres.map((cc, i) => (
                        <Card role="button" xs={12} sm={6} md={4} lg={3} key={i} onClick={() => handleControlCentreConfig(cc.controlCentreId, cc.controlCentreText)} className='carditem'>
                            <Card.Body>
                                <Card.Title>{cc.controlCentreText}</Card.Title>
                            </Card.Body>
                        </Card>
                    ))
                    }
                </Stack>
            )}
            {loading && (<Spinner animation="border" variant="secondary" size="md" />)}
        </Container>
    );
}